import { atom } from "jotai"

export const DefaultComponentAtom = {
    isLogoutButtonShown: true,
    userId: null,
    profileTypeId: null,
    courseEditData: null
}

export const ComponentAtom = atom(DefaultComponentAtom)
